import UserOutlined from '@ant-design/icons/UserOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import SolutionOutlined from '@ant-design/icons/SolutionOutlined';
import { t } from 'i18n';

const identity = {
  id: 'group-identity',
  title: t('Identity & Access'),
  type: 'group',
  children: [
    { id: 'users', title: t('Staff Users'), type: 'item', url: '/identity/users', icon: UserOutlined },
    { id: 'roles', title: t('Roles'), type: 'item', url: '/identity/roles', icon: SafetyCertificateOutlined },
    { id: 'register-requests', title: t('Registration Requests'), type: 'item', url: '/identity/register-requests', icon: SolutionOutlined }
  ]
};

export default identity;
